export default "__VITE_ASSET__BefgKp2P__"